export const enum Path {
	HOME = '/',

	SIGNUP = '/signup',

	LOGIN = '/login',
	GENERIC_LOGIN = '/genericLogin',
	FORGOT = '/auth/forgot',
	RESET = '/reset',
	RESET_ACTIVATION = '/auth/resetActivation/:token',

	MAGIC_LINK_LOGIN = '/auth/magicLinkLogin',
	REQUEST_MAGIC_LINK = '/auth/requestMagicLink',

	JOURNEY_MANAGER = '/journeymanager',
	JOURNEY_OVERVIEW = '/journeymanager/overview',
	JOURNEY_SETTINGS = '/journeymanager/:storyId',
	JOURNEY_EDIT = '/journeymanager/:storyId/edit',
	JOURNEY_STEP_EDIT = '/journeymanager/:storyId/step/:stepId',

	JOURNEY = '/journeys/:storyId/:stepId?',

	MESSAGE_CREATE = '/message/create',
	MESSAGE_VIEW = '/message/:postId',
	MESSAGE_UPDATE = '/message/update/:postId',

	PAGE_CREATE = '/page/create',
	PAGE_VIEW = '/page/:typeId?/:pageId',

	GROUP_CREATE = '/group/create',
	GROUP_VIEW = '/group/:slug',
}
